<div class="slider custom-slider centered flex-start-end">
  <!-- <span><em class="icon-edit"></em></span> -->
  <ngx-slider [(value)]="value" (valueChange)="setValue($event)" [options]="options"></ngx-slider>
  <!-- <span><em class="icon-edit"></em></span> -->
</div>
<div class="center">
  <button [disabled]="!canContinue" id="actionButton" class="btn btn-primary btn-lg" (click)="moveNext()" [innerHTML]="_properties.text1"></button>
</div>
